<template>
  <div class="bigdata_container" id="bigdata">
    <!-- <div id="container" class="mymap"></div> -->
    <div class="header">
      <div class="header-title">绩溪县养老大数据</div>
      <div class="header-nav">
        <a
          :class="{ active: $route.name === 'hgVisit' }"
          @click="pageChange('/hgVisit')"
          >老龄人口数据</a
        >
        <a
          :class="{ active: $route.name === 'hgVisit1' }"
          @click="pageChange('/hgVisit1')"
          >机构养老数据</a
        >
        <a
          :class="{ active: $route.name === 'hgVisit2' }"
          @click="pageChange('/hgVisit2')"
          >养老机构点</a
        >
      </div>
      <div class="header-time">
        {{ time }}
      </div>
    </div>
    <div class="quanp">
      <el-button id="fullScreen" @click="showFullScreen" type="primary"
        >{{ onFullScreen ? "退出全屏" : "进入全屏" }}
      </el-button>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import baseURL from "@/api/baseURL"
import request from "@/utils/request.js"
export default {
  name: "visualized",
  data() {
    return {
      clickIndex: 1,
      infoTisp: false,
      isLoading: false,
      keyword: "", //搜索
      onFullScreen: false, // 是否全屏
      time: "",
      areaList: [],
    }
  },
  // activated() {
  created() {
    this.interval = setInterval(() => {
      let currentDT = new Date()
      let y, m, date, day, hs, ms, ss, theDateStr
      y = currentDT.getFullYear() //四位整数表示的年份
      m = currentDT.getMonth() + 1 //月
      date = currentDT.getDate() //日
      hs = currentDT.getHours() //时
      ms = currentDT.getMinutes() //分
      ss = currentDT.getSeconds() //秒
      this.time = y + "-" + m + "-" + date + " " + hs + ":" + ms + ":" + ss
    }, 1000)

    // this.$nextTick(() => {
    //   this.loadMap().then(() => {
    //     this.getDistrict()
    //   })
    // })
  },
  mounted() {
    const self = this
    document.addEventListener(
      "fullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "msfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "mozfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "webkitfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )
  },
  methods: {
    //页面跳转
    pageChange(name) {
      this.$router.replace(
        { path: name },
        (onComplete) => {},
        (onAbort) => {}
      )
    },
    check(i) {
      var num = i < 10 ? "0" + i : i
      return num
    },

    // 控制全屏展示
    showFullScreen() {
      this.onFullScreen = !this.onFullScreen
      if (this.onFullScreen) {
        var docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm = document.body //overwrite the element (for IE)
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    FullCreeen(element) {
      let el = document.getElementById("bigdata")
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el)
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell")
        if (wscript != null) {
          wscript.SendKeys("{F11}")
        }
      }
    },

    // loadMap() {
    //   //地图加载
    //   return new Promise((resolve, reject) => {
    //     this.map = new AMap.Map("container", {
    //       resizeEnable: true,
    //       mapStyle: "amap://styles/darkblue",
    //       zoom: 9,
    //       center: ['118.57', '30.07'],
    //     })
    //     resolve()
    //   })
    // },
    drawArea() {
      for (let i = 0; i < this.areaList.length; i++) {
        // console.log(this.areaList,'2222')
        this.getArea(this.areaList[i].adcode, this.areaList[i].color)
      }
    },
    getArea(name, color) {
      // console.log(name, color)
      const self = this
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let bounds = result.districtList[0].boundaries
          self.polygons = []
          for (var i = 0, l = bounds.length; i < l; i++) {
            self.polygon = new AMap.Polygon({
              map: self.map,
              strokeWeight: 1,
              strokeColor: "#007CDB",
              fillColor: color,
              fillOpacity: 0.06,
              path: bounds[i],
            })
            self.polygons.push(self.polygon)
          }
          // self.map.setFitView() //地图自适应
        }
      })
    },
    getDistrict(name = "341824", params = null) {
      let self = this
      // return new Promise((resolve, reject) => {
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }

      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let areaList = []
          result.districtList[0].districtList.forEach((item) => {
            console.log(item, "下次code")
            areaList.push({
              adcode: item.adcode,
              name: item.name,
            })
          })
          areaList[0].color = "#24609C"
          areaList[1].color = "#467399"
          areaList[2].color = "#0C2FA0"
          areaList[3].color = "#3769A6"
          areaList[4].color = "#22598D"
          areaList[5].color = "#326A9D"
          areaList[6].color = "#0C2FA0"
          areaList[7].color = "#2568A2"
          areaList[8].color = "#134CA2"
          areaList[9].color = "#183B77"
          areaList[10].color = "#183B70"
          areaList[11].color = "#183B70"

          self.areaList = areaList
          self.drawArea()
        }
      })
    },
  },
  beforeDestory() {
    window.removeEventListener("resize")
  },
}
</script>

<style lang="less" scoped>
#container {
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  bottom: 0;
  z-index: 1;
}

.nameoftransition-enter-active,
.nameoftransition-leave-active {
  transition: opacity 0.5s;
}

.nameoftransition-enter, .nameoftransition-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

//引入的字体样式
//@font-face {
//  font-family: "Unidtrsmled";
//  src: url(./assets/font/UnidreamLED.ttf);
//}

.quanp {
  width: 200px;
  height: 100px;
  float: right;
  position: absolute;
  top: 20px;
  right: -110px;
  z-index: 100;

  button {
    padding: 10px;
  }
}

.bigdata_container {
  * {
    box-sizing: content-box;
  }
}

/deep/ .el-carousel__container {
  height: 100% !important;

  .el-icon-arrow-left:before,
  .el-icon-arrow-right:before {
    color: #489aff;
    font-weight: bold;
    font-size: 22px;
  }
}
.mymap {
  width: 100%;
  height: 100vh;
}
.bigdata_container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url("./assets/imgs/bg.png") no-repeat center center;
  background-size: 100% 100%;

  .header {
    margin: auto;
    width: 90%;
    height: 100px;
    background: url("./assets/imgs/头部@2x.png") no-repeat center center;
    background-size: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 80px;
    box-sizing: border-box;
  }
  .header-title {
    color: #00d2ff;
    font-size: 26px;
    font-weight: bold;
  }

  .header-nav {
    display: flex;
    flex: 1;
    text-align: center;

    & > a {
      color: #1c47b1;
      border-top: 1px solid #1c47b1;
      border-bottom: 1px solid #1c47b1;
      padding: 5px 0;
      margin: 0 40px;
      position: relative;
      font-size: 20px;
      width: 230px;
      cursor: pointer;
      display: block;
      text-decoration: none;
    }
    & > a.active {
      background-image: linear-gradient(to right, #02cafd, #2570e9);
    }

    & > a.active:after {
      background: #02cafd;
    }
    & > a.active:before {
      background: #2570e9;
    }

    & > a:after {
      content: "";
      width: 24px;
      height: 24px;
      border-top: 1px solid #1c47b1;
      border-right: 1px solid #1c47b1;
      transform: rotate(-135deg);
      position: absolute;
      left: -5.5%;
      top: 13%;
    }

    & > a:before {
      content: "";
      width: 24px;
      height: 24px;
      border-top: 1px solid #1c47b1;
      border-right: 1px solid #1c47b1;
      transform: rotate(46deg);
      position: absolute;
      left: 94.5%;
      top: 15%;
    }
  }

  .header-time {
    color: #1c47b1;
    font-size: 24px;
  }
  .main_left {
    margin-top: 2%;
    position: absolute;
    width: 20%;
    height: calc(100vh - 100px);
    margin-left: 1%;
    z-index: 2;

    .left {
      margin-top: 2%;
      width: 100%;
      padding-left: 1%;

      .headerBox {
        margin-left: 10px;
        line-height: 50px;
        height: 50px;
        color: #01c5e2;
      }

      .iconBox {
        height: calc(100% - 50px);
        display: flex;

        .box {
          color: #fff;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          display: flex;

          .img {
            img {
              margin: 0 10%;
              width: 80%;
            }
          }

          .txt {
            font-size: 15px;

            span {
              font-size: 30px;
              font-family: Unidtrsmled;
            }
          }
        }
      }
    }

    .left_top {
      // background: url(./assets/imgs/a3.png);
      background-size: 100% 100%;
      height: 17vh;
    }

    .left_center {
      margin-top: 20px;
      background: url(./assets/imgs/left.png);
      background-size: 100% 100%;
      height: 31vh;

      .typeClick {
        margin-right: 10px;
        float: right;
        color: #fff;
        position: relative;
        z-index: 1000;

        .active {
          padding-bottom: 2px;
          border-bottom: 1px solid #038bff;
        }

        span {
          margin: 0 10px;
        }
      }

      .type {
        height: 24.5vh;
        width: 100%;
      }
    }

    .left_bottom {
      margin-top: 20px;
      border: 1px solid #3755da;

      .type {
        height: 60vh;
        width: 100%;
      }
    }
  }
  .main_right2 {
    margin-top: 1.5%;
    position: absolute;
    right: 21%;
    width: 31.5%;
    margin-right: 1%;
    height: calc(100vh - 100px);
    z-index: 2;
    .right {
      margin-top: 3%;
      width: 100%;
      padding-left: 1%;
    }
    .right_top2 {
      border: 1px solid #3755da;
      .type1 {
        height: 232px;
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
    }
    .right_center2 {
      .box {
        display: flex;
        justify-content: space-between;
        li {
          width: 140px;
          height: 107px;
          background: #0a2043;
          border: 1px solid #3755da;
        }
      }
    }
  }
  .main_right {
    margin-top: 2%;
    position: absolute;
    right: 0;
    width: 20%;
    margin-right: 1%;
    height: calc(100vh - 100px);
    z-index: 2;

    .right {
      margin-top: 2%;
      width: 100%;
      padding-left: 1%;

      .headerBox {
        margin-left: 10px;
        line-height: 50px;
        height: 50px;
        color: #01c5e2;
      }

      .iconBox {
        height: calc(100% - 50px);
        display: flex;

        .box {
          color: #fff;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          display: flex;

          .img {
            img {
              margin: 0 10%;
              width: 80%;
            }
          }

          .txt {
            font-size: 15px;

            span {
              font-size: 30px;
              font-family: Unidtrsmled;
            }
          }
        }
      }
    }

    .right_top {
      // background: url(./assets/imgs/right.png);
      // background-size: 100% 100%;
      border: 1px solid #3755da;
      .type1 {
        height: 33vh;
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
    }

    .right_center {
      // background: url(./assets/imgs/right.png);
      // background-size: 100% 100%;
      border: 1px solid #3755da;
      .type {
        height: 33vh;
        width: 100%;
      }
    }

    .right_bottom {
      // background: url(./assets/imgs/right.png);
      // background-size: 100% 100%;
      border: 1px solid #3755da;

      .type {
        height: 23vh;
        width: 100%;

        .li {
          padding-left: 4px;
          font-size: 14px;
          display: flex;
          margin-top: 10px;
          flex-direction: row;
          color: #fff;
          line-height: 24px;
          height: 24px;

          .img {
            border-radius: 50%;
            width: 24px !important;
            height: 24px !important;
            background: #489aff;
            text-align: center;
            font-size: 8px;
          }

          .txt {
            margin-left: 10px;
            width: 20%;
            overflow: hidden;
            height: 18px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }

          .time {
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }
        }
      }

      .flex1 {
        display: flex;
        flex-direction: column;
      }
    }
  }
}

// 回访内容
.return_visit_form {
  .formheader {
    display: flex;
    justify-content: space-between;
    padding: 24px 0 36px;
  }
}
.person-data {
  display: flex;
  justify-content: space-between;
  .box {
    border: 1px solid #3755da;
    width: 85px;
    text-align: center;
    height: 100px;
    p {
      color: #2968e8;
      font-size: 16px;
    }
    span {
      color: #f21b62;
      font-size: 26px;
    }
  }
}
</style>
